import { useCallback, useState } from "react";

const COLLAPSE_STORAGE_KEY = "rc_internal_sidebar_collapsed";

interface UseInternalLayoutResult {
  collapsed: boolean;
  toggleCollapsed: () => void;
}

/** Sidebar collapse state for the internal shell, persisted across sessions. */
export function useInternalLayout(): UseInternalLayoutResult {
  const [collapsed, setCollapsed] = useState<boolean>(
    () => localStorage.getItem(COLLAPSE_STORAGE_KEY) === "1"
  );

  const toggleCollapsed = useCallback(() => {
    setCollapsed((prev) => {
      const next = !prev;
      localStorage.setItem(COLLAPSE_STORAGE_KEY, next ? "1" : "0");
      return next;
    });
  }, []);

  return { collapsed, toggleCollapsed };
}
